import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useMemo } from 'react';
import { closestCenter, DndContext, KeyboardSensor, MouseSensor, TouchSensor, useSensor, useSensors } from '@dnd-kit/core';
import { arrayMove, SortableContext, sortableKeyboardCoordinates, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { getTestIds } from '../../utils/TestIds';
import { useBiAction } from '../BiTracking';
import { List } from '../List';
import { SortableListItem } from './SortableListItem';
export const reorderItems = (items, activeId, overId)=>{
    const oldIndex = items.findIndex((item)=>item.id === activeId);
    const newIndex = items.findIndex((item)=>item.id === overId);
    if (oldIndex === -1 || newIndex === -1) {
        return items;
    }
    return arrayMove(items, oldIndex, newIndex);
};
const MOUSE_SENSOR_OPTIONS = {
    activationConstraint: {
        distance: 5
    }
};
const TOUCH_SENSOR_OPTIONS = {
    activationConstraint: {
        delay: 200,
        tolerance: 5
    }
};
const KEYBOARD_SENSOR_OPTIONS = {
    coordinateGetter: sortableKeyboardCoordinates
};
export const SortableList = (param)=>{
    let { items, onReorder, renderItem, getDragLabel, className, itemClassName, testId, bi, noBi: _noBi } = param;
    const testIds = useMemo(()=>getTestIds(testId), [
        testId
    ]);
    const logBiAction = useBiAction();
    const sensors = useSensors(useSensor(MouseSensor, MOUSE_SENSOR_OPTIONS), useSensor(TouchSensor, TOUCH_SENSOR_OPTIONS), useSensor(KeyboardSensor, KEYBOARD_SENSOR_OPTIONS));
    const sortableIds = useMemo(()=>items.map((item)=>item.id), [
        items
    ]);
    const handleDragEnd = useCallback((event)=>{
        const { active, over } = event;
        if (!over || active.id === over.id) {
            return;
        }
        const reordered = reorderItems(items, String(active.id), String(over.id));
        if (reordered === items) {
            return;
        }
        onReorder(reordered);
        if (bi === null || bi === void 0 ? void 0 : bi.name) {
            logBiAction({
                entityType: 'sortable_list',
                entityName: bi.name,
                actionType: 'reorder',
                data: _object_spread_props(_object_spread({}, bi.data), {
                    testId: testId !== null && testId !== void 0 ? testId : '',
                    fromId: String(active.id),
                    toId: String(over.id)
                })
            });
        }
    }, [
        items,
        onReorder,
        bi,
        logBiAction,
        testId
    ]);
    return /*#__PURE__*/ _jsx(DndContext, {
        sensors: sensors,
        collisionDetection: closestCenter,
        onDragEnd: handleDragEnd,
        children: /*#__PURE__*/ _jsx(SortableContext, {
            items: sortableIds,
            strategy: verticalListSortingStrategy,
            children: /*#__PURE__*/ _jsx(List, {
                disablePadding: true,
                className: className,
                "data-testid": testIds.root(),
                children: items.map((item)=>/*#__PURE__*/ _jsx(SortableListItem, {
                        id: item.id,
                        itemTestId: testIds.item(item.id),
                        handleTestId: testIds.dragHandle(item.id),
                        dragLabel: getDragLabel === null || getDragLabel === void 0 ? void 0 : getDragLabel(item),
                        className: itemClassName,
                        children: renderItem(item)
                    }, item.id))
            })
        })
    });
};
